import {official} from '../base-service/service';

export default {
    // 获取系统时间
    getSystemDate(data = {}) {
        return official('/getSystemDate.do', data);
    }
};
